import Vue from 'vue';
import axios from 'axios';
import packageJson from '@/../package.json';
import router from '@/router';

const vueInstance = new Vue();
const version = packageJson.version;

// axios.defaults.baseURL = 'https://test.ysbang.cn';
axios.defaults.timeout = 30000;
// 网络错误重试配置项
axios.defaults.retry = 2;
axios.defaults.retryDelay = 1000;
axios.interceptors.response.use(undefined, (err) => {
  const config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(() => axios(config));
});

const SERVERCODE = {
  success: '40001',
  nologin: '40020'
};

/**
 *
 * @param options {url:'',params:{},errorCaback}
 * @returns {*}
 */
function get(options) {
  return request(options, 'get');
}

function post(options) {
  return request(options, 'post');
}

function xmlPost(options) {
  return xmlRequest(options, 'post');
}

export function getParamFromUrl(name, _location) {
  const url = _location || window.location.search; // window.location.search：URL中问号及其后面的内容
  const reg = new RegExp(`(^|&|&amp;)${name}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = decodeURI(url.substr(1)).match(reg); // 匹配目标参数

  return r == null ? '' : unescape(r[2]);
}

function request(options, method) {
  const token = localStorage.getItem('token') || getParamFromUrl('token');
  const showErrMessage = options.showErrMessage !== undefined ? options.showErrMessage : false; // 默认显示错误提示

  if (!options.params) {
    options.params = {
      token,
      ex: router.app?._route?.name
    };
  }

  if (!options.params.token) {
    options.params.token = token;
  }

  /* eslint-disable */
  // 调用接口时加上构建时间
  if (AppInfo.buildTime) {
    options.params.buildTime = AppInfo.buildTime;
  }
  /* eslint-disable */

  options.params.version = version;
  return new Promise((resolve, reject) => {
    const axiosOption = {
      method,
      url: options.url,
      timeout: options.timeout || 30000,
      responseType: 'json',
      cancelToken: options.cancelToken,
    };

    if (options.retry !== undefined) { // 接收调用接口时retry参数
      axiosOption.retry = options.retry;
    }
    if (method === 'get') {
      axiosOption.params = options.params;
    } else if (method === 'post') {
      axiosOption.data = options.params;
    }

    axios(axiosOption)
      .then((response) => {
        if (response.status === 200) {
          switch (response.data.code) {
            case SERVERCODE.success:
            {
              resolve(response.data);
              break;
            }
            case SERVERCODE.nologin:
            {
              window.location.hash = '/login';
              window.location.reload();
              reject(response.data);
              break;
            }
            default:
            {
              if (showErrMessage) vueInstance.$Notice.error({ desc: response.data.message });
              alert(response.data.message);
              reject(response.data);
              break;
            }
          }
        } else {
          alert(response.data.message || response.message());
          if (showErrMessage) vueInstance.$Notice.error({ desc: response.data.message || response.message() });
          reject(response.data);
        }
      }).catch((error) => {
        if (!axios.isCancel(error)) vueInstance.$Notice.error({ desc: error });
        reject(error.response || error);
      });
  });
}

function xmlRequest(options, method) {
  const token = localStorage.getItem('token');
  if (!options.params) {
    options.params = {
      token
    };
  }

  if (options.params.token == null) {
    options.params.token = token;
  }

  return new Promise((resolve, reject) => {
    const {
      responseType, url, timeout, params
    } = options;
    const axiosOption = {
      method,
      url,
      timeout: timeout || 30000,
    };

    if (responseType) axiosOption.responseType = responseType;

    if (method === 'get') {
      axiosOption.params = params;
    } else if (method === 'post') {
      axiosOption.data = params;
    }
    axios(axiosOption)
      .then((response) => {
        resolve(response);
      }).catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

const ajaxUtil = {
  get,
  post,
  xmlPost
};

export default ajaxUtil;
